import { SeoHead } from "@/components/common/SeoHead";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { HeroSection } from "@/components/home/HeroSection";
import { TrustStrip } from "@/components/home/TrustStrip";
import { FeaturedDestinations } from "@/components/home/FeaturedDestinations";
import { TourPackagesSection } from "@/components/home/TourPackagesSection";
import { FlightDealsSection } from "@/components/home/FlightDealsSection";
import { CruiseSection } from "@/components/home/CruiseSection";
import { AirlineLogosStrip } from "@/components/home/AirlineLogosStrip";
import { HowItWorks } from "@/components/home/HowItWorks";
import { PolarExpeditionsSection } from "@/components/home/PolarExpeditionsSection";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { Testimonials } from "@/components/home/Testimonials";
import { ServicesLinksSection } from "@/components/home/ServicesLinksSection";
import { Newsletter } from "@/components/home/Newsletter";
import { useEffect } from "react";

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <SeoHead
        title="Travel Planning Made Simple"
        description="Tripsyfy helps families, groups, and busy travelers book flights, tours, cruises, and custom trips with human support from start to finish."
        canonical="https://tripsyfy.com/"
      />
      <Navbar />
      <HeroSection />
      <TrustStrip />
      <AirlineLogosStrip />
      <HowItWorks />
      <FeaturedDestinations />
      <TourPackagesSection />
      <FlightDealsSection />
      <CruiseSection />
      <PolarExpeditionsSection />
      <WhyChooseUs />
      <ServicesLinksSection />
      <Testimonials />
      <Newsletter />
      <Footer />
    </div>
  );
}
